import { msg } from '@lingui/core/macro';

import { filterAction } from '@/shared/filters/filter-action';
import { listPageAction } from '@/shared/patterns/list-search';
import { action } from '@/shared/screen/define';

import { preparedAction } from './beneficiary-limits.screen';
import { transferListFilters } from './transfer.filters';

// Ações da aba Transferências (U2b, U23/U24), acrescentadas ao manifesto do detalhe. Leve: o fio entra
// pela tela.
//
// Ficam fora, de propósito: Cancelar, Comprovante e Detalhes (presos a uma linha: precisariam de chave de
// alvo na entrada, que a trava `agent-tool-targets` recusa) e Exportar PDF (feito só na tela). A nova TED,
// aprovar e reprovar pedem senha e código MFA e **só preparam**: nenhum valor, favorecido, documento ou
// conta passa pela ferramenta.

/** "Atualizar" (`TransferHeaderList.tsx:21-24,45-50`): a lista e o saldo da conta. */
export const transfersRefresh = action({
  id: 'bankAccount.transfers.refresh',
  kind: 'read',
  label: msg`Atualizar`,
  description: msg`Busca de novo a lista de transferências e o saldo da conta aberta. Nada é alterado.`,
  run: () => undefined,
});

export const transfersFilter = filterAction('bankAccount.transfers.filter', transferListFilters, {
  description: msg`Filtra a lista de transferências (TED) da conta aberta: ted_searchString (todos os campos), ted_transferDate (data da ocorrência, AAAA-MM-DD), ted_beneficiaryName (nome do favorecido), ted_beneficiaryRegistrationNumber (CPF/CNPJ, dígitos e letras) e ted_status (Approved, Pending, Rejected, Timeout, Canceled, Error, Processing, Finished). Filtro omitido é limpo.`,
});

export const transfersPage = listPageAction('bankAccount.transfers.page');

/** A paginação da lista na conta transitória (somente leitura), no manifesto dela. */
export const transitoryTransfersPage = listPageAction('bankAccount.transitory.transfers.page');

/** "Transferir" (`HeaderTransfer.tsx:97-101`): a pessoa escolhe o favorecido, digita o valor e confirma com senha e código. */
export const transfersCreate = preparedAction(
  'bankAccount.transfers.create',
  msg`Transferir`,
  'write',
  msg`Abre o formulário de nova transferência (TED) da conta aberta, em branco. Quem escolhe o favorecido, digita o valor, a finalidade e a data e confirma com a senha e o código MFA é a pessoa: esta ferramenta não transfere nada. Não recebe entrada.`,
  msg`Transferir`,
);

/** "Aprovar" e "Reprovar" do cabeçalho (`TransferHeaderList.tsx:30-44`): pedem senha e código MFA. */
export const transfersApprove = preparedAction(
  'bankAccount.transfers.approve',
  msg`Aprovar`,
  'write',
  msg`Prepara a aprovação das transferências marcadas na lista da conta aberta. Só abre o diálogo de senha e código MFA, com a quantidade e o total: esta ferramenta não aprova nada. Não recebe entrada; os alvos são as linhas marcadas na página aberta, todas aguardando aprovação.`,
  msg`Aprovar transferência`,
);

export const transfersReject = preparedAction(
  'bankAccount.transfers.reject',
  msg`Reprovar`,
  'destructive',
  msg`Prepara a reprovação das transferências marcadas na lista da conta aberta. Só abre o diálogo de senha e código MFA, com a quantidade e o total: esta ferramenta não reprova nada. Não recebe entrada; os alvos são as linhas marcadas na página aberta, todas aguardando aprovação.`,
  msg`Rejeitar transferência`,
);

/** As ações novas do detalhe, para o `actions` do manifesto. */
export const TRANSFER_ACTIONS = [transfersRefresh, transfersFilter, transfersPage, transfersCreate, transfersApprove, transfersReject];
